import { render } from "./BtnWhats.vue?vue&type=template&id=4a038dfa&scoped=true"
import script from "./BtnWhats.vue?vue&type=script&lang=js"
export * from "./BtnWhats.vue?vue&type=script&lang=js"

import "./BtnWhats.vue?vue&type=style&index=0&id=4a038dfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a038dfa"]])

export default __exports__